import { useMutation } from '@tanstack/react-query';
import { orderService } from '../services/order.service';
import { CreateOrderRequest, CreateOrderResponse, ApiError } from '../types';

export interface UseCreateOrderResult {
  mutate: (request: CreateOrderRequest) => void;
  mutateAsync: (request: CreateOrderRequest) => Promise<CreateOrderResponse>;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: ApiError | null;
  data: CreateOrderResponse | undefined;
  reset: () => void;
}

export function useCreateOrder(): UseCreateOrderResult {
  const mutation = useMutation<CreateOrderResponse, ApiError, CreateOrderRequest>({
    mutationFn: async (request: CreateOrderRequest) => {
      return await orderService.createOrder(request);
    },
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error || null,
    data: mutation.data,
    reset: mutation.reset,
  };
}
